import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store/store';

const SimplifiedHeader: React.FC = () => {
  const navigate = useNavigate();
  const { routesPrefix } = useSelector((state: RootState) => state.setup);
  const storeInfo = useSelector((state: RootState) => state.products.storeInfo);

  return (
    <div className="w-full flex flex-col items-center justify-center py-[32px]">
      <div
        className="flex flex-col items-center gap-[12px] cursor-pointer"
        onClick={() => navigate(`${routesPrefix}`)}
      >
        {storeInfo?.coverImage && (
          <img
            src={storeInfo.coverImage}
            className="h-[64px] object-contain"
            alt={storeInfo?.name}
          />
        )}
        {storeInfo?.name && (
          <span className="font-bold text-[18px] text-primary-800 font-dmsans">
            {storeInfo.name}
          </span>
        )}
      </div>
    </div>
  );
};

export default SimplifiedHeader;
